export default "__VITE_ASSET__9972af50__"